import {ICON_TYPES} from '../constants';

export const AirConditionerIcon = (): JSX.Element => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M18.375 0H2.625C1.17775 0 0 1.17775 0 2.625V9.625H21V2.625C21 1.17775 19.8223 0 18.375 0ZM19.25 7.875H1.75V2.625C1.75 2.14287 2.142 1.75 2.625 1.75H18.375C18.858 1.75 19.25 2.14287 19.25 2.625V7.875ZM3.5 4.375H17.5V6.125H3.5V4.375ZM6.125 11.375H7.875V17.5C7.875 19.4303 6.30525 21 4.375 21C2.44475 21 0.875 19.4303 0.875 17.5C0.875 15.5697 2.44475 14 4.375 14V15.75C3.40987 15.75 2.625 16.5349 2.625 17.5C2.625 18.4651 3.40987 19.25 4.375 19.25C5.34013 19.25 6.125 18.4651 6.125 17.5V11.375ZM20.125 17.5C20.125 19.4303 18.5553 21 16.625 21C14.6947 21 13.125 19.4303 13.125 17.5V11.375H14.875V17.5C14.875 18.4651 15.6599 19.25 16.625 19.25C17.5901 19.25 18.375 18.4651 18.375 17.5C18.375 16.5349 17.5901 15.75 16.625 15.75V14C18.5553 14 20.125 15.5697 20.125 17.5ZM9.625 11.375H11.375V21H9.625V11.375Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

AirConditionerIcon.iconType = ICON_TYPES.AIR_CONDITIONER;
